import { Heading } from '../Common'
import React from 'react'
import styled from 'styled-components'
import { FaqProps } from './faq.props'
import { Question } from './Components/Question'

export const Faq = ({ title, contents }: FaqProps) => {
  return (
    <Container>
      <Heading as="h1" data={title} className="mt-0 pt-0" />
      <QuestionListContainer>
        {contents.map((content) => {
          return (
            <QuestionItem key={`Question__${content.question}`}>
              <Question {...content} />
            </QuestionItem>
          )
        })}
      </QuestionListContainer>
    </Container>
  )
}

const Container = styled.section`
  & > .pt-5 {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
`

const QuestionListContainer = styled.ul.attrs({
  className: 'row g-4',
})`
  list-style: none;
`

const QuestionItem = styled.li.attrs({
  className: 'col-12',
})``
